import React from 'react';

type IconButtonProps = {
  icon: React.ReactNode | JSX.Element;
  shape?: boolean;
  disabled?: boolean;
  size?: 'small' | 'big';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  className?: string;
  dataTestId?: string;
  tabIndex?: number;
};
const AurIconButton: React.FC<IconButtonProps> = ({
  icon,
  shape = false,
  disabled = false,
  size = 'small',
  onClick,
  ariaLabel,
  ariaDescribedBy,
  className = '',
  dataTestId = '',
  tabIndex,
}) => {
  const buttonSize = size === 'small' ? 32 : 40;
  const accessibleText = ariaLabel?.trim();
  return (
    <button
      type='button'
      className={`${'icon-button'} ${
        shape ? 'with-shape' : ''
      } ${disabled ? 'disabled' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: `${buttonSize}px`,
        height: `${buttonSize}px`,
      }}
      aria-label={accessibleText}
      aria-describedby={ariaDescribedBy ?? undefined}
      data-testid={dataTestId}
      tabIndex={tabIndex}
    >
      {icon}
    </button>
  );
};

export default AurIconButton;
